import React, { useState } from "react";
import "./Service.css";
import { Link } from "react-router-dom";
import PageSEO from "../../SEO/PageSEO";
import heroServicesImg from "../../../images/home-doctor-visit-uganda.jpeg";

const serviceCategories = [
  {
    category: "Home & Visiting Services",
    icon: "home-outline",
    desc: "We come to you - wherever you are.",
    items: [
      { name: "Doctor Home Visit",                          icon: "home-outline",            slug: "doctor-home-visit" },
      { name: "Hospital at Home Care",                      icon: "bed-outline",             slug: "hospital-at-home" },
      { name: "Nursing & Bedside Medical Care",             icon: "bandage-outline",         slug: "nursing-bedside-care" },
      { name: "Patient Follow-up & Chronic Medicare",       icon: "refresh-circle-outline",  slug: "chronic-disease-care" },
      { name: "Visiting Doctors (Institution & Individual)",icon: "person-outline",          slug: "visiting-doctors" },
      { name: "Remote Patient Monitoring",                  icon: "pulse-outline",           slug: "remote-patient-monitoring" },
    ],
  },
  {
    category: "Maternal & Child Health",
    icon: "woman-outline",
    desc: "Compassionate care for mothers and children.",
    items: [
      { name: "Midwife Consultation & Antenatal Care",  icon: "woman-outline",    slug: "antenatal-maternal-care" },
      { name: "Virtual Doctor & Midwife Consultations", icon: "videocam-outline", slug: "telemedicine" },
      { name: "Family Planning",                         icon: "heart-outline",    slug: "family-planning" },
      { name: "Paediatrician",                           icon: "happy-outline",    slug: "paediatrician" },
      { name: "Gynaecologist",                           icon: "medical-outline",  slug: "gynaecologist" },
    ],
  },
  {
    category: "Corporate & Community Health",
    icon: "business-outline",
    desc: "Health solutions for workplaces and communities.",
    items: [
      { name: "Corporate Staff Medical Assessment", icon: "business-outline", slug: "corporate-health-assessment" },
      { name: "School Student Medical Examination", icon: "school-outline",   slug: "school-medical-examination" },
      { name: "Community Outreach",                  icon: "people-outline",   slug: "community-outreach" },
      { name: "Medical Camp",                        icon: "medkit-outline",   slug: "medical-camp" },
      { name: "Healthcare Campaign",                 icon: "megaphone-outline",slug: "healthcare-campaign" },
      { name: "Environmental Healthcare Consultancy",icon: "leaf-outline",     slug: "environmental-health" },
    ],
  },
  {
    category: "Specialist & Surgical Services",
    icon: "flask-outline",
    desc: "Expert specialist care on your terms.",
    items: [
      { name: "General Doctor Consult",           icon: "medical-outline",  slug: "general-consultation" },
      { name: "Elective Surgical Services",        icon: "cut-outline",      slug: "elective-surgery" },
      { name: "Surgeon",                           icon: "bandage-outline",  slug: "surgeon" },
      { name: "Dental Care Services",              icon: "happy-outline",    slug: "dental-care" },
      { name: "Referral & Link to Tertiary Care",  icon: "link-outline",     slug: "referral-tertiary" },
      { name: "Ambulance Services",                icon: "car-outline",      slug: "ambulance" },
    ],
  },
  {
    category: "Mental Health",
    icon: "heart-circle-outline",
    desc: "Supporting your mind as much as your body.",
    items: [
      { name: "Mental Health Services",   icon: "heart-circle-outline", slug: "mental-health" },
      { name: "Psychiatric Healthcare",   icon: "ribbon-outline",        slug: "psychiatry" },
      { name: "Psychologist Services",    icon: "chatbubble-outline",    slug: "psychologist" },
    ],
  },
  {
    category: "Laboratory, Pharmacy & Imaging",
    icon: "flask-outline",
    desc: "Diagnostics and medicines at your convenience.",
    items: [
      { name: "Laboratory Sample Pick-up", icon: "flask-outline",        slug: "laboratory" },
      { name: "Pharmacy",                  icon: "medkit-outline",       slug: "pharmacy" },
      { name: "Medicine Delivery",         icon: "bicycle-outline",      slug: "medicine-delivery" },
      { name: "Medicine Refill",           icon: "refresh-outline",      slug: "medicine-refill" },
      { name: "Ultrasound Scan",           icon: "scan-outline",         slug: "ultrasound" },
      { name: "X-ray",                     icon: "scan-circle-outline",  slug: "x-ray" },
      { name: "CT Scan",                   icon: "aperture-outline",     slug: "ct-scan" },
      { name: "MRI",                       icon: "radio-outline",        slug: "mri" },
      { name: "Angiogram",                 icon: "pulse-outline",        slug: "angiogram" },
      { name: "Equipment Purchase",        icon: "cart-outline",         slug: "equipment" },
    ],
  },
];

const processSteps = [
  { num: "1", title: "Contact Us",  desc: "Call, WhatsApp or use our online booking form." },
  { num: "2", title: "We Confirm",  desc: "Our team confirms your appointment within 2 hours." },
  { num: "3", title: "We Arrive",   desc: "A qualified professional comes to your location." },
  { num: "4", title: "You Heal",    desc: "Receive quality care and follow-up support." },
];

const servicesStructuredData = {
  "@context": "https://schema.org",
  "@type": "ItemList",
  "name": "Yitalife Healthcare Services",
  "description": "Comprehensive home-based and outdoor healthcare services by Yitalife - Yita Medical Services Uganda",
  "url": "https://www.yitalife.com/Services",
  "itemListElement": [
    { "@type": "ListItem", "position": 1, "name": "Doctor Home Visit",             "url": "https://www.yitalife.com/services/doctor-home-visit" },
    { "@type": "ListItem", "position": 2, "name": "Hospital at Home Care",         "url": "https://www.yitalife.com/services/hospital-at-home" },
    { "@type": "ListItem", "position": 3, "name": "Antenatal & Maternal Care",     "url": "https://www.yitalife.com/services/antenatal-maternal-care" },
    { "@type": "ListItem", "position": 4, "name": "Corporate Health Assessment",   "url": "https://www.yitalife.com/services/corporate-health-assessment" },
    { "@type": "ListItem", "position": 5, "name": "Telemedicine",                  "url": "https://www.yitalife.com/services/telemedicine" },
    { "@type": "ListItem", "position": 6, "name": "Chronic Disease Care",          "url": "https://www.yitalife.com/services/chronic-disease-care" },
    { "@type": "ListItem", "position": 7, "name": "School Medical Examination",    "url": "https://www.yitalife.com/services/school-medical-examination" },
    { "@type": "ListItem", "position": 8, "name": "Mental Health Services",        "url": "https://www.yitalife.com/services/mental-health" },
    { "@type": "ListItem", "position": 9, "name": "Community Outreach",            "url": "https://www.yitalife.com/services/community-outreach" },
  ]
};

export default function Service() {
  return (
    <div>
      <PageSEO
        title="Our Healthcare Services - Home Visits, Telemedicine & More"
        description="Yitalife offers doctor home visits, hospital at home care, antenatal care, corporate health assessments, telemedicine, mental health services, community outreach, and more - across Uganda. A service of Yita Medical Services (YMS)."
        canonical="https://www.yitalife.com/Services"
        structuredData={servicesStructuredData}
      />

      {/* ── HERO ── */}
      <div className="page-hero" style={{ backgroundImage: `url(${heroServicesImg})` }}>
        <div className="container page-hero-content">
          <h1 data-aos="fade-down">Our Healthcare Services</h1>
          <p data-aos="fade-up" data-aos-delay="80">
            Comprehensive, doctor-led healthcare delivered to your door; by Yitalife, a service of Yita Medical Services (YMS)
          </p>
          <div className="page-breadcrumb">
            <Link to="/">Home</Link>
            <ion-icon name="chevron-forward-outline" style={{ fontSize: "13px" }}></ion-icon>
            <span>Services</span>
          </div>
        </div>
      </div>

      {/* ── SERVICES CATALOGUE ── */}
      <section className="services-page-section">
        <div className="container">
          <div className="services-page-header" data-aos="fade-up">
            <div className="badge-yita" style={{ margin: "0 auto 14px" }}>
              <ion-icon name="medkit-outline"></ion-icon>
              Full Service Catalogue
            </div>
            <h2>All Yitalife Services</h2>
            <p>
              Professional, equitable healthcare across specialties -
              delivered with expertise and care.
            </p>
          </div>

          {serviceCategories.map((cat, ci) => (
            <div key={ci} style={{ marginBottom: "56px" }}>
              <div className="service-category-heading" data-aos="fade-right">
                <div className="service-category-icon">
                  <ion-icon name={cat.icon}></ion-icon>
                </div>
                <div>
                  <h3>{cat.category}</h3>
                  <p style={{ margin: 0, fontSize: "14px", color: "var(--text-muted)", fontFamily: "Inter, sans-serif" }}>{cat.desc}</p>
                </div>
              </div>
              <div className="row g-3">
                {cat.items.map((item, ii) => (
                  <div
                    className="col-lg-4 col-md-6 col-sm-12"
                    key={ii}
                    data-aos="fade-up"
                    data-aos-delay={Math.min(ii * 50, 300)}
                  >
                    <Link
                      to={`/services/${item.slug}`}
                      className="service-page-card-link"
                      aria-label={`Learn about ${item.name}`}
                    >
                      <div className="service-page-card">
                        <div className="service-page-icon">
                          <ion-icon name={item.icon}></ion-icon>
                        </div>
                        <h5>{item.name}</h5>
                        <span className="service-learn-more">
                          Learn more <ion-icon name="arrow-forward-outline"></ion-icon>
                        </span>
                      </div>
                    </Link>
                  </div>
                ))}
              </div>
            </div>
          ))}

          {/* CTA Card */}
          <div className="services-cta-card" data-aos="fade-up">
            <div style={{ fontSize: "52px", color: "var(--primary)", marginBottom: "12px" }}>
              <ion-icon name="calendar-outline"></ion-icon>
            </div>
            <h3>Ready to Book a Service?</h3>
            <p>Our qualified medical team is available 24 hours a day, 7 days a week.</p>
            <div className="services-cta-btns">
              <Link to="/Appointment">
                <button className="btn-book">Book an Appointment</button>
              </Link>
              <Link to="/Contact">
                <button className="btn-contact">Contact Us</button>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* ── HOW IT WORKS ── */}
      <section className="services-process-strip">
        <div className="container">
          <div style={{ textAlign: "center", marginBottom: "56px" }} data-aos="fade-up">
            <div className="badge-yita" style={{ margin: "0 auto 14px", background: "rgba(255,255,255,0.12)", color: "rgba(255,255,255,0.9)", border: "1px solid rgba(255,255,255,0.2)" }}>
              <ion-icon name="information-circle-outline"></ion-icon>
              Simple Process
            </div>
            <h2 style={{ color: "var(--white)", fontSize: "2rem", fontFamily: "Playfair Display, serif" }}>How It Works</h2>
            <p style={{ color: "rgba(255,255,255,0.68)", fontSize: "18px", maxWidth: "480px", margin: "0 auto" }}>
              Getting quality healthcare has never been this easy.
            </p>
          </div>
          <div className="row g-4 justify-content-center">
            {processSteps.map((step, i) => (
              <div className="col-lg-3 col-md-6" key={i} data-aos="fade-up" data-aos-delay={i * 80}>
                <div className="process-step">
                  <div className="process-step-num">{step.num}</div>
                  <h5>{step.title}</h5>
                  <p>{step.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
